const sqrt = Math.sqrt;
const sq = (x) => Math.pow(x,2);

export const getGeometry = (coordinates) => {
    if (coordinates.length === 0) {
        return {
            x: 0,
            y: 0,
            diameter: 1
        };
    }
    let xArray = new Uint32Array(coordinates.map(({x,y}) => x));
    let yArray = new Uint32Array(coordinates.map(({x,y}) => y));
    
    let x = window.api.create_geometry_buffer(coordinates.length);
    let y = window.api.create_geometry_buffer(coordinates.length);
    let out = window.api.create_geometry_buffer(3);
    
    window.Module.HEAP32.set(xArray, x / xArray.BYTES_PER_ELEMENT);
    window.Module.HEAP32.set(yArray, y / yArray.BYTES_PER_ELEMENT);
    window.api.getGeometry(x,y,coordinates.length,out);
    
    const resultView = new Uint32Array(window.Module.HEAP32.buffer, out, 3);
    let centroidX = resultView[0];
    let centroidY = resultView[1];
    let diameter = resultView[2];
    
    window.api.destroy_buffer(out);
    window.api.destroy_buffer(x);
    window.api.destroy_buffer(y);
    
    return {
        x: centroidX,
        y: centroidY,
        diameter
    };
};

export const centroid = (coordinates) => {
    return getGeometry(coordinates);
};

export const diameter = (coordinates) => {
    return getGeometry(coordinates).diameter;
};
